// translations.js
export const translations = {
  de: {
    title: 'Stammdaten der Vertragsparteien',
    contractor: {
      title: 'Auftragnehmer',
      company: 'Firma',
      registration: 'Registrierung',
      representative: 'Vertretungsberechtigter',
      contact: 'Ansprechpartner'
    },
    client: {
      title: 'Auftraggeber',
      company: 'Firma',
      street: 'Straße',
      zipCode: 'PLZ',
      city: 'Ort',
      registration: 'Registrierung',
      vatId: 'USt-IdNr / Steuernummer',
      representative: 'Vertretungsberechtigte(r)',
      contractContact: 'Vertraglicher Ansprechpartner',
      technicalContact: 'Technischer Ansprechpartner',
      optional: '(optional)',
      technicalContactHint: 'Nur erforderlich, falls der Auftraggeber direkt in die Projektdurchführung involviert ist',
      billingAddress: 'Rechnungsadresse',
      billingAddressPlaceholder: 'Falls abweichend von Firmensitz',
      contactName: 'Name',
      contactPhone: 'Telefon',
      contactEmail: 'E-Mail'
    },
    billing: {
      title: 'Abrechnungsmodalitäten',
      deliveryMethod: 'Rechnungszustellung',
      deliveryOptions: {
        zugferd: 'ZUGFeRD 2.x (Standard)',
        xInvoice: 'XRechnung',
        portal: 'Rechnungsportal',
        postal: 'Postversand'
      },
      changeDeliveryMethod: 'Andere Zustellungsart wählen',
      billingEmail: 'E-Mail für Rechnungen',
      standardDeliveryInfo: 'Standardmäßig versenden wir PDF-Rechnungen mit eingebetteten strukturierten Daten (ZUGFeRD 2.x)',
      zugferdDetails: 'ZUGFeRD 2.x ist ein hybrides Rechnungsformat, das zwei Elemente verbindet: 1) Eine menschenlesbare PDF/A-3-Rechnung, die normal angezeigt und gedruckt werden kann, und 2) Eingebettete maschinenlesbare XML-Daten nach EN16931-Standard, die eine automatisierte Verarbeitung in Buchungssystemen ermöglichen. Dies erlaubt sowohl manuelle als auch automatisierte Verarbeitung desselben Dokuments.',
      routingId: 'Leitweg-ID',
      portalUrl: 'Portal-URL/Name',
      additionalInfo: 'Zusatzangaben auf Rechnungen',
      poRequired: 'Bestellreferenz',
      poNumber: 'Bestellnummer/PO',
      projectRef: 'Projektreferenz',
      projectId: 'Projektcode/ID',
      costCenter: 'Kostenstelle',
      costCenterNumber: 'Kostenstellennummer',
      otherRequirements: 'Weitere Anforderungen',
      otherRequirementsPlaceholder: 'Zusätzliche Anforderungen an die Rechnungsstellung'
    },
    errors: {
      noToken: 'Kein gültiger Link gefunden. Bitte fordern Sie einen neuen Link an.',
      invalidToken: 'Der Link ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.',
      validationError: 'Fehler bei der Überprüfung des Links. Bitte versuchen Sie es später erneut.',
      unknownError: 'Ein unbekannter Fehler ist aufgetreten.'
    },
    messages: {
      validating: 'Link wird überprüft...',
      saving: 'Wird gespeichert...',
      saveSuccess: 'Daten wurden erfolgreich gespeichert.',
      saveError: 'Fehler beim Speichern der Daten.'
    },
    validation: {
      required: '{field} ist ein Pflichtfeld',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      formErrors: 'Bitte korrigieren Sie die folgenden Fehler:',
    },
    save: 'Speichern',
    saveSuccess: 'Daten erfolgreich gespeichert',
    saveError: 'Fehler beim Speichern der Daten'
  },
  en: {
    title: 'Master Data of Contracting Parties',
    contractor: {
      title: 'Contractor',
      company: 'Company',
      registration: 'Registration',
      representative: 'Authorized Representative',
      contact: 'Contact Person'
    },
    client: {
      title: 'Client',
      company: 'Company',
      street: 'Street',
      zipCode: 'ZIP Code',
      city: 'City',
      registration: 'Registration',
      vatId: 'VAT ID / Tax Number',
      representative: 'Authorized Representative',
      contractContact: 'Contract Contact Person',
      technicalContact: 'Technical Contact Person',
      optional: '(optional)',
      technicalContactHint: 'Only required if the client is directly involved in project implementation',
      billingAddress: 'Billing Address',
      billingAddressPlaceholder: 'If different from company address',
      contactName: 'Name',
      contactPhone: 'Phone',
      contactEmail: 'Email'
    },
    billing: {
      title: 'Billing Modalities',
      deliveryMethod: 'Invoice Delivery',
      deliveryOptions: {
        zugferd: 'ZUGFeRD 2.x (Standard)',
        xInvoice: 'XInvoice',
        portal: 'Invoice Portal',
        postal: 'Postal Mail'
      },
      changeDeliveryMethod: 'Choose different delivery method',
      billingEmail: 'Email for invoices',
      standardDeliveryInfo: 'By default, we send PDF invoices with embedded structured data (ZUGFeRD 2.x)',
      zugferdDetails: 'ZUGFeRD 2.x combines a readable PDF invoice with structured XML data according to EN16931, making it a valid e-invoice format for automated processing.',
      routingId: 'Routing ID',
      portalUrl: 'Portal URL/Name',
      additionalInfo: 'Additional Invoice Information',
      poRequired: 'Purchase order reference',
      poNumber: 'PO Number',
      projectRef: 'Project reference',
      projectId: 'Project Code/ID',
      costCenter: 'Cost center',
      costCenterNumber: 'Cost Center Number',
      otherRequirements: 'Other Requirements',
      otherRequirementsPlaceholder: 'Additional invoicing requirements'
    },
    errors: {
      noToken: 'No valid link found. Please request a new link.',
      invalidToken: 'The link is invalid or expired. Please request a new link.',
      validationError: 'Error validating the link. Please try again later.',
      unknownError: 'An unknown error occurred.'
    },
    messages: {
      validating: 'Validating link...',
      saving: 'Saving...',
      saveSuccess: 'Data saved successfully.',
      saveError: 'Error saving data.'
    },
    validation: {
      required: '{field} is required',
      invalidEmail: 'Please enter a valid email address',
      formErrors: 'Please correct the following errors:',
    },
    save: 'Save',
    saveSuccess: 'Data saved successfully',
    saveError: 'Error saving data'
  }
};